import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Review } from '../review-types';
import { ReviewApiService } from '@vendasta/reputation';
import { ReviewHistory } from '@vendasta/reputation';
import { Observable, startWith } from 'rxjs';
import { getImageSrc } from '../../common/utils';
import { DateFormat } from '@vendasta/galaxy/utility/date-utils';
import { map } from 'rxjs/operators';
import { starCount } from '../../common/utils';

interface State {
  loading: boolean;
  reviewHistory: reviewHistoryWithStarRating[];
}

interface reviewHistoryWithStarRating {
  reviewHistory: ReviewHistory;
  stars: number[];
}

@Component({
  selector: 'reviews-review-history-card',
  templateUrl: './review-history-card.component.html',
  styleUrls: ['./review-history-card.component.scss'],
  standalone: false,
})
export class ReviewHistoryCardComponent implements OnInit {
  state$: Observable<State>;
  emptyImagePath = getImageSrc('Noreviewhistory.svg');
  reviewStars: number[];
  protected readonly DateFormat = DateFormat;

  constructor(
    @Inject(MAT_DIALOG_DATA) public review: Review,
    private reviewHistoryService: ReviewApiService,
  ) {}

  ngOnInit() {
    this.state$ = this.reviewHistoryService
      .getReviewHistory({
        reviewId: this.review.reviewID,
      })
      .pipe(
        map((result) => {
          const reviewHistoryWithStarRating = result.reviewHistory
            ? result.reviewHistory.map((reviewHistory) => {
                const scaledStarRating = reviewHistory.scaledStarRating || 0;
                return {
                  reviewHistory: reviewHistory,
                  stars: starCount(this.getStarsFromScaledStarRating(scaledStarRating)),
                };
              })
            : null;
          return {
            loading: false,
            reviewHistory: reviewHistoryWithStarRating,
          };
        }),
        startWith({
          loading: true,
          reviewHistory: [],
        }),
      );

    this.reviewStars = starCount(this.review.stars);
  }

  getStarsFromScaledStarRating(scaledStarRating: number): number {
    return scaledStarRating / 250 + 1;
  }
}
